import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";
import CustomerCategoryLabel from "../components/CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as idiProjectActions from "../actions/IdiProjectActions";

const IdiProjectSearch  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.idi.loading);
    const list = useSelector((state) => state.idi.list);
    const filter = useSelector((state) => state.idi.filter);
    const user = useSelector((state) => state.login.user);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(idiProjectActions.loadIdiProjectSearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(idiProjectActions.setIdiProjectFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(idiProjectActions.loadIdiProjectSearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(idiProjectActions.setIdiProjectFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(idiProjectActions.setIdiProjectFilter(copy_filter));
    }

    const exportToExcel = () => {
        dispatch(idiProjectActions.downloadIdiProjectSearch(filter, "IDI Projects.xlsx"));
    }
    
    return(
        <Fragment>
            <div className="page-content">
            <Container fluid>
                    <BreadCrumb title="IDI Project Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={user && user.canAddIdiProject ? 8 : 10} md={12}>
                                            <MySearchOption
                                                placeholder={"Search for IDI Projects..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                        {user && user.canAddIdiProject &&
                                        <Col xxl={2} md={12}>
                                            <Link to={`/idi-project-add`} className="btn btn-primary w-100">
                                                <i className="ri-add-line align-bottom"></i> Add IDI Project
                                            </Link>
                                        </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th>Project #</th>
                                                    <th>Current Stage</th>
                                                    <th>Lot Ref #</th>
                                                    <th>Source Name</th>
                                                    <th>Tawuniya Ref #</th>
                                                    <th>Balady Ref #</th>
                                                    <th>Customer Name</th>
                                                    <th>Owner Name</th>
                                                    <th>Action Date</th>
                                                    <th>Date Added</th>
                                                    <th>Added By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/idi-project-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td style={{whiteSpace: "nowrap"}}>
                                                                <div>{item.projectNumber}</div>
                                                            </td>
                                                            <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                            <td>{item.lotRefNo}</td>
                                                            <td>{item.sourceName}</td>
                                                            <td>{item.tawuniyaRefNo}</td>
                                                            <td>{item.baladyRefNo}</td>
                                                            <td>{item.customerName}</td>
                                                            <td>{item.ownerName}</td>
                                                            <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                            <td><MyDateRenderer value={item.dateAdded} /></td>
                                                            <td>{item.addedBy}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                                onExportToExcel={() => exportToExcel()}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IdiProjectSearch;